import apiRequest from "apiRequest";
import { endPoints } from "apis";

/**
 * Fetch service types with optional pagination and search parameters.
 * @param {Object} params
 * @returns {Promise<any>}
 */
export const fetchServiceTypes = async (params = {}) => {
  return apiRequest.get(endPoints.GET_SERVICE_TYPES, params);
};

/**
 * Create a new service type.
 * @param {FormData} data
 * @returns {Promise<any>}
 */
export const createServiceType = async (data) => {
  return apiRequest.post(endPoints.ADD_SERVICE_TYPE, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * Update an existing service type.
 * @param {Object} options
 * @param {number|string} options.id
 * @param {FormData} options.data
 * @returns {Promise<any>}
 */
export const updateServiceType = async ({ id, data }) => {
  return apiRequest.put(`${endPoints.UPDATE_SERVICE_TYPE}/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * Delete a service type by id.
 * @param {number|string} id
 * @returns {Promise<any>}
 */
export const deleteServiceType = async (id) => {
  return apiRequest.delete(`${endPoints.DELETE_SERVICE_TYPE}/${id}`);
};

/**
 * Update service type status.
 * @param {Object} options
 * @param {number|string} options.id
 * @param {"active"|"inactive"} options.status
 * @returns {Promise<any>}
 */
export const updateServiceTypeStatus = async ({ id, status }) => {
  return apiRequest.put(`${endPoints.STATUS_SERVICE_TYPE}/${id}`, { status });
};
